import { Button, Column } from '@codeparva/ui-components-library';
import { Link } from 'gatsby';
import React from 'react';
import { weakKey } from '../../../../utilities/weakKey';
import { FooterTypes } from './footerTypes';

export const FooterCTAButtons = ({
  buttonsConfig,
}: FooterTypes.TLabelsLogoandCityStateNames) => {
  enum ctaButtonColor {
    'cp-primary-button-highlighted',
    'cp-outlined-button-highlighted',
  }
  enum textColor {
    'has-text-white',
    'has-text-accent',
  }
  return (
    <Column className="footerColumnThree is-hidden-mobile">
      <div className="CTAButtons">
        {buttonsConfig &&
          buttonsConfig.map((button, index) => (
            <Button
              className={`button ${ctaButtonColor[index]}`}
              key={weakKey({ button })}
            >
              <Link
                to={button.url}
                className={textColor[index]}
                state={{
                  from: button.label.toLowerCase().replace(/\s/g, ''),
                }}
              >
                {button.label}
              </Link>
            </Button>
          ))}
      </div>
    </Column>
  );
};
